import RemoteCall from "../../util/RemoteCall";

const remoteCall = new RemoteCall("/api/noAuth/wxcptp/auth");
const _remoteCall = new RemoteCall("/api/wxcptp");

// {wxCorpId, pc}
const getNoLoginUrlAsync = async (params) => {
    return remoteCall.invoke("getNoLoginUrl", params);
};

// {code, state}
const noLoginAsync = async (params) => {
    return remoteCall.invoke("noLogin", params);
};

// {agentConfig, wxCorpID, url}
const getConfigAsync = async (params) => {
    return _remoteCall.invoke("getConfig", params);
};

export default {
    getNoLoginUrlAsync,
    noLoginAsync,
    getConfigAsync,

};
